export const games: Array<{ id: string; title: string; description: string }> = [
    {
        id: 'rpg',
        title: 'Pangea 2D',
        description: 'RPG-игра Пангея основана на выживании в открытом мире. Вам предстоит управлять персонажем и передвигаться по карте, исследуя различные локации, добывать ресурсы, крафтить всевозможное оружие и убивать толпы монстров в данжах!'
    },
    {
        id: 'farm',
        title: 'Весёлый фермер',
        description: 'Возьми под контроль убыточную ферму и преврати её в настоящий процветающий бизнес! Выращивай растения, ухаживай за милыми животными и развивай своё производство!'
    },
    // {
    //     id: 'age',
    //     title: 'Эпоха: Эволюция',
    //     description: 'Пробейся сквозь толпу врагов и захвати вражеские земли! В игре Эпоха: Эволюция тебе предстоит взять под своё предводительство отряд доблестных воинов и с помощью правильной стратегии привести его к победе! '
    // },
    {
        id: 'words',
        title: 'Слова из слова',
        description: 'Увлекательная игра, цель которой - составлять всевозможные слова из выданных слов.'
    },
    {
        id: 'cross',
        title: 'Кроссворд',
        description: 'Угадывайте слова по определениям и загадкам, используйте подсказки и пройдите все уровни игры!'
    },
    {
        id: 'brain',
        title: 'Тренажёр мозга',
        description: 'В игре "Тренажёр мозга" вы найдёте множество различных игр-упражнений, которые не только принесут вам удовольствие, но и будут развивать такие высшие психические функции, как внимание, память, мышление.'
    },
];
export const gamesEN = [
    {
        id: 'rpg',
        title: 'Pangea 2D',
        description: 'The RPG game Pangea is based on survival in the open world. You have to control the character and move around the map, exploring various locations, mining resources, crafting all kinds of weapons and killing crowds of monsters in the dungeons!'
    },
    {
        id: 'farm',
        title: 'Lucky Farmer',
        description: 'Take control of an unprofitable farm and turn it into a real thriving business! Grow plants, take care of cute animals and develop your production!'
    },
    // {
    //     id: 'age',
    //     title: 'Era: Evolution',
    //     description: 'Fight your way through the crowd of enemies and capture enemy lands! In the game Era: Evolution, you have to take under your leadership a detachment of valiant warriors and lead them to victory with the right strategy!'
    // },
];

export const jobs: Array<{ title: string; requirements: string[]; link: string }> = [
    {
        title: 'HTML-5 разработчик',
        requirements: [
            'Знание и опыт JavaScript и / или TypeScript',
            'Знание и опыт использования HTML-5 игровых движков,(любого из: Phaser, Construct, Cocos2d-js, Pixi.js, PlayCanvas, Three,js, Defold, Cocos2d-x, CocosCreator)',
            'Понимание основ WebGL',
            'Умение и опыт разработки игр',
            'Понимание нюансов и особенностей игровой веб-разработки',
        ],
        link: 'https://t.me/RiddikZ'
    },
    {
        title: 'Геймдизайнер',
        requirements: [
            'Опыт создания геймдизайна',
            'Умение создавать и актуализировать дизайн-документы',
            'Умение настраивать игровой баланс и кор-геймплей',
            'Понимание, как улучшать игру после выпуска',
            'Понимание, как правильно передавать понятное ТЗ дизайнерам и программистам'
        ],
        link: 'https://t.me/Andreifreidman'
    }
];

export const jobsEN: Array<{ title: string; requirements: string[]; link: string }> = [
    {
        title: 'HTML-5 developer',
        requirements: [
            'Knowledge and experience of JavaScript and/or TypeScript',
            'Knowledge and experience of using HTML-5 game engines, ,(any of: Phaser, Construct, Cocos2d-js, Pixi.js, PlayCanvas, Three,js, Defold, Cocos2d-x, CocosCreator)',
            'Understanding the basics of WebGL',
            'Skill and experience in game development',
            'Understanding the nuances and features of HTML-5 development',
        ],
        link: 'https://t.me/RiddikZ'
    },
    {
        title: 'Game designer',
        requirements: [
            'Experience in creating a game design',
            'Ability to create and update design documents',
            'Ability to adjust the game balance and core gameplay',
            'Understanding how to improve the game after release',
            'Understanding how to correctly give clear technical specifications to designers and programmers'
        ],
        link: 'https://t.me/Andreifreidman'
    }
];